import React from 'react'
import styled from 'styled-components'
import settings from '../../../components/settings'
import StoreSelection from '../../../components/store-selection/StoreSelection'
import MeetingTypeSelection from '../../../components/meeting-type-selection'
import SlotSelection from '../../../components/slot-selection'
import CustomerForm from '../../../components/customer-form'
import Confirmation from '../../../components/confirmation'
import Loader from '../../../components/loader/Loader'

const Row = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  position: relative;
  ${(p) =>
    p.show &&
    `
    margin-bottom: 100px;
  `}
`

const SelectLoader = styled.div`
  height: 42px;
  padding: 26px;
`

const LoaderWithProps = (props) =>
  props.loading && (
    <SelectLoader>
      <Loader duration={3} />
    </SelectLoader>
  )

const StepStores = ({
  show,
  props: {
    storeId,
    store,
    stores,
    fallbackAddress,
    selectedAddress,
    selectedCity,
    selectedStore,
    selectedStoreUnavailable,
    checked,
    onChange,
    storesByAddressData,
    customerAddress,
    storeIsPreSelectable,
    flow,
    allowAutoSelect,
  },
}) =>
  show && (
    <StoreSelection
      storeIsPreSelectable={storeIsPreSelectable}
      storeId={storeId}
      store={store}
      checked={checked}
      stores={
        stores &&
        stores.filter(
          (item) =>
            settings.excludedStudioTypes.indexOf(item.storeType) === -1 &&
            !item.hideInBada
        )
      }
      onChange={onChange}
      fallbackAddress={fallbackAddress}
      selectedAddress={selectedAddress}
      selectedCity={selectedCity}
      selectedStore={selectedStore}
      selectedStoreUnavailable={selectedStoreUnavailable}
      customerAddress={customerAddress}
      loading={storesByAddressData.loading}
      error={storesByAddressData.error != null}
      flow={flow}
      allowAutoSelect={allowAutoSelect}
    />
  )

const StepMeetingType = ({ show, refProp, props }) => {
  if (!show) return null
  return (
    <Row ref={refProp}>
      <MeetingTypeSelection {...props} />
    </Row>
  )
}

const StepBookingSlot = ({
  show,
  props: {
    selectedStore,
    selectedService,
    onChange,
    onMount,
    selectedServiceProvider,
    flow,
    updateUiState,
  },
}) =>
  show && (
    <>
      <Row>
        <SlotSelection
          selectedStore={selectedStore}
          selectedService={selectedService}
          onChange={onChange}
          onMount={onMount}
          selectedServiceProvider={selectedServiceProvider}
          flow={flow}
          updateUiState={updateUiState}
        />
      </Row>
    </>
  )

const StepSubmit = ({
  show,
  props: {
    selectedStore,
    selectedSlot,
    selectedService,
    onUpdate,
    onMount,
    values,
    previousQuestions,
    addHistory,
    updateUiState,
    overrideMeetingType,
    flow,
    selectedServiceProvider,
  },
}) =>
  show && (
    <CustomerForm
      selectedService={selectedService}
      selectedSlot={selectedSlot}
      selectedStore={selectedStore}
      updateUiState={updateUiState}
      addHistory={addHistory}
      onUpdate={onUpdate}
      values={values}
      previousQuestions={previousQuestions}
      onMount={onMount}
      overrideMeetingType={overrideMeetingType}
      flow={flow}
      selectedServiceProvider={selectedServiceProvider}
    />
  )

const StepConfirmation = ({
  show,
  props: {
    selectedStore,
    selectedSlot,
    selectedService,
    booking,
    values,
    onMount,
    staff,
    appointmentId,
    appointment,
    returningVisitor,
  },
}) =>
  show && (
    <Confirmation
      selectedStore={selectedStore}
      selectedService={selectedService}
      selectedSlot={selectedSlot}
      booking={booking}
      customerValues={values}
      onMount={onMount}
      staff={staff}
      appointmentId={appointmentId}
      appointment={appointment}
      returningVisitor={returningVisitor}
    />
  )

export {
  StepStores,
  StepMeetingType,
  StepBookingSlot,
  StepSubmit,
  StepConfirmation,
  LoaderWithProps,
}
